import template from './favoriteButton.html';

let component = {
	template,
	transclude: true,
	bindings: {
		uid: '='
	},
	controller: function(Favorite) {
		"ngInject";

		var vm = this;

		vm.active = Favorite.inList(vm.uid);

		this.add = () => {
			Favorite.add(vm.uid).then(() => {
				vm.active = Favorite.inList(vm.uid);
			});
			
		};
	}
};

export default component;


// WEBPACK FOOTER //
// ./app/components/favoriteButton/favoriteButton.component.js